import iFrameResize from 'iframe-resizer/js/iframeResizer.min';

import '../../css/blocks/iframe.css';

window.iFrameResize = iFrameResize;

const IFRAME_ID = 'iFrameResizer0';
const NAVIGATION_OFFSET = 95;
const SCROLL_TRIGGER_VALUES = [0, 230];

// This configuration is for sewobe only - If iframes will be used generally, this needs to be handles separately.
window.addEventListener('message', (event) => {
    const value = Number(event.data);

    if (!SCROLL_TRIGGER_VALUES.includes(value)) {
        return;
    }

    const iframe = document.getElementById(IFRAME_ID);

    if (!iframe) {
        return;
    }

    const scrollPosition = iframe.getBoundingClientRect().top - NAVIGATION_OFFSET;

    window.scrollBy({
        top: scrollPosition,
        behavior: 'smooth',
    });
});
